module.exports = __webpack_public_path__ + "static/media/slider_plataforms.791c13b6.png";